import { BlockquoteIcon } from '@/components/icons/BlockquoteIcon';
import { HeadingLargeIcon } from '@/components/icons/HeadingLargeIcon';
import { HeadingMediumIcon } from '@/components/icons/HeadingMediumIcon';
import { HeadingSmallIcon } from '@/components/icons/HeadingSmallIcon';
import { TextListBulletedIcon } from '@/components/icons/TextListBulletedIcon';
import { TextListNumberedIcon } from '@/components/icons/TextListNumberedIcon';
import { Type01Icon } from '@/components/icons/Type01Icon';

export const blockTypeToBlockName = {
  code: 'Code Block',
  h1: 'Large heading',
  h2: 'Medium heading',
  h3: 'Small heading',
  h4: 'Heading',
  h5: 'Heading',
  h6: 'Heading',
  ol: 'Numbered list',
  paragraph: 'Body',
  quote: 'Quote',
  ul: 'Bulleted list',
} as const;

export const iconProps = {
  size: 20,
};

export const blockTypeToBlockIcon = {
  code: null,
  h1: HeadingLargeIcon,
  h2: HeadingMediumIcon,
  h3: HeadingSmallIcon,
  h4: null,
  h5: null,
  h6: null,
  ol: TextListNumberedIcon,
  paragraph: Type01Icon,
  quote: BlockquoteIcon,
  ul: TextListBulletedIcon,
} as const;

export type Block = keyof typeof blockTypeToBlockName;
